import RealTimeNotificationMessage from './real-time-notification-message';

export default RealTimeNotificationMessage;
